import { ref, onMounted, onUnmounted, computed, watch } from "vue"
import store from "@/store"

export function useWindowSize() {
  const maxTabletSize = computed(() => store.getters["global/maxTabletSize"])

  const TABLET = ref({
    from: 768,
    to: maxTabletSize.value,
  })

  const MOBILE = ref({
    from: 0,
    to: 768,
  })

  watch(maxTabletSize, (newMaxTabletSize) => {
    TABLET.value.to = newMaxTabletSize
    update()
  })

  const isTablet = ref(
    window.innerWidth > TABLET.value.from &&
      window.innerWidth <= TABLET.value.to
  )
  const isMobile = ref(
    window.innerWidth > MOBILE.value.from &&
      window.innerWidth <= MOBILE.value.to
  )

  const update = () => {
    const mobileChanged =
      window.innerWidth > MOBILE.value.from &&
      window.innerWidth <= MOBILE.value.to
    const tabletChanged =
      window.innerWidth > TABLET.value.from &&
      window.innerWidth <= TABLET.value.to

    if (mobileChanged !== isMobile.value) {
      isMobile.value = mobileChanged
    } else if (tabletChanged !== isTablet.value) {
      isTablet.value = tabletChanged
    }
  }

  onMounted(() => {
    window.addEventListener("resize", update)
  })

  onUnmounted(() => {
    window.removeEventListener("resize", update)
  })

  return { isTablet, isMobile }
}
